import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
    ChangeDetectorRef,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { I1FilenetServices } from 'src/app/acl-data/i1-filenet-services.service';
import { environment } from 'src/environments/environment';
import { SubSink } from 'subsink';
import { MatDialog } from '@angular/material/dialog';
import { PopupConfirmationComponent } from 'src/app/modal/popup-confirmation/popup-confirmation.component';
import { FolderService } from 'src/app/acl-data/folder/folder.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    templateUrl: './usermanagement.component.html',
    styleUrls: ['./usermanagement.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsermanagementComponent implements OnInit, OnDestroy {
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    subs = new SubSink();
    loading$ = new BehaviorSubject(false);
    update$ = new BehaviorSubject(null);
    users;

    objectStore$ = this.route.paramMap.pipe(
        withLatestFrom(this.route.data),

        map(([_, x]) => {
            return x
        })
    )

    users$ = this.i1FilenetServices
        .getAllUsers()
        .pipe(
            map(v =>
                v.sort((a, b) =>
                    a.username.toLowerCase() > b.username.toLowerCase() ? 1 : -1
                )
            )
        );
    members$ = this.i1FilenetServices
        .getMembers(environment.usersGroup)
        .pipe(
            map(v =>
                v.sort((a, b) =>
                    a.username.toLowerCase() > b.username.toLowerCase() ? 1 : -1
                )
            )
        );
    userSearch = '';
    username;
    filterValue = '';

    members;
    membersDisplay;

    dataSource;
    displayedColumns: string[] = [
        'Action',
        'Username',
        'Firstname',
        'Lastname',
        'emailAddress',
    ];

    displayChange() {
        if (this.members && !this.membersDisplay) {
            this.membersDisplay = this.members;
        }
        if (this.membersDisplay) {
            this.dataSource = new MatTableDataSource<any>(this.membersDisplay);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.cdr.detectChanges();
        }

    }

    constructor(
        private i1FilenetServices: I1FilenetServices,
        private _snackBar: MatSnackBar,
        private cdr: ChangeDetectorRef,
        private dialog: MatDialog, //new,
        private folderService: FolderService,
        private route: ActivatedRoute
    ) { }

    ngOnDestroy(): void {
        this.subs.unsubscribe();

    }

    ngOnInit() {
        this.subs.add(this.users$.subscribe(v => (this.users = v)));
        this.subs.add(
            this.members$.subscribe(v => {
                this.members = v;
                // console.log(v);
                this.displayChange();
            })
        );
    }

    //new 

    delete = (input: string) => {
        console.log('Delete', input);
        this.loading$.next(true);

        this.objectStore$.pipe(
            switchMap(x => {
                return this.i1FilenetServices
                    .deleteMember(input, x.parentMenu.data.parentMenu.path)
            })
        ).subscribe(v => {

            this._snackBar.open('User Deleted Successfully', 'Dismiss');

            this.i1FilenetServices
                .removeMember(input, environment.usersGroup)
                .pipe(switchMap(v => this.members$))
                .subscribe(
                    v => {

                        this.members = v;
                        this.applyFilter(this.filterValue);
                        this.loading$.next(false);
                        this.displayChange();
                    },
                    e => {
                        this.loading$.next(false);
                        this._snackBar.open('Unable to remove user', 'Dismiss')
                    }

                );
        },

            e => {
                this.loading$.next(false);
                this._snackBar.open('Unable to Delete user, Please contact your System administrator.', 'Dismiss')
            });

        this.folderService.clearCache(); // clears the cache so user doesnt have to refresh the page

    };

    confirmDelete = (input: string) => {
        console.log("Opening Delete Pop Up");
        const dialogRef = this.dialog.open(PopupConfirmationComponent, {
            data: {
                title: 'Confirm Delete?',
                description: 'This will remove the user from all Libraries and Documents.\nAre you sure you want to continue?',
                option1: 'Yes',
                option2: 'No'
            },

        });

        dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed', result);
            if (result == "Yes") {
                this.delete(input);
            }
            console.log("dialog Create after close event");
        });
    };


    add = (input: string) => {
        console.log('Add', input);
        this.i1FilenetServices
            .addMember(input, environment.usersGroup)
            .pipe(switchMap(v => this.members$))
            .subscribe(
                v => {
                    this.members = v;
                    this.applyFilter(this.filterValue);
                    this.displayChange();

                    this._snackBar.open('User added', 'Dismiss');
                },
                e => this._snackBar.open('Unable to add user', 'Dismiss')
            );
    };

    applySort(input: Sort) {
        this.dataSource.sortChanged(input);
    }

    stringFilterBy(input, list: any[]) {
        // return list;
        if (!list) {
            return [];
        }

        const inputValue = input.trim().toLowerCase();
        return list.filter(
            v =>
                (v.username &&
                    v.username
                        .trim()
                        .toLowerCase()
                        .indexOf(inputValue) >= 0) ||
                (v.firstName &&
                    v.firstName
                        .trim()
                        .toLowerCase()
                        .indexOf(inputValue) >= 0) ||
                (v.lastName &&
                    v.lastName
                        .trim()
                        .toLowerCase()
                        .indexOf(inputValue) >= 0)
        );
    }

    applyFilter(filterValue: string) {
        if (!filterValue || !this.members) {
            this.membersDisplay = this.members;
            return;
        }
        console.info('Filter', filterValue);
        const value = filterValue.trim().toLowerCase();

        this.membersDisplay = this.members.filter(
            v =>
                JSON.stringify(v)
                    .toLowerCase()
                    .indexOf(value) >= 0
        );

        if (this.paginator) {
            this.paginator.firstPage();
        }

        this.displayChange();
    }
}
